export default "__VITE_ASSET__DeSlnGtH__"